<script lang="ts">
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import { mainMenu } from '../../../stores/store';
    import JobModifyTimeWindowRule from './JobModifyTimeWindowRule.svelte';
    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import TemplateHeaderTrio from '../../shared/TemplateHeaderTrio.svelte';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import ButtonSmallBlue from '../../shared/ButtonSmallBlue.svelte';
    import { JobModifyTimeWindowRuleApi } from './JobModifyTimeWindowRuleApi';
    import { api } from '../../../stores/api';
    import IconPending from '../../shared/Icons/IconPending.svelte';
    import ModalCustom from '../../shared/Modals/ModalCustom.svelte';
    import { openModal } from 'svelte-modals';
    import JobModifyTimeWindowRuleAdd from './JobModifyTimeWindowRuleAdd.svelte';
    // TEMPORARY IMPORT - DELETE AFTER CSV IMPORT IS COMPLETE
    import CsvImportButton from './CsvImportButton.svelte';
    import SearchInput from '../../shared/SearchInput.svelte';
    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import ButtonSmallBlack from '../../shared/ButtonSmallBlack.svelte';
    import ButtonSmallDanger from '../../shared/ButtonSmallDanger.svelte';

    let addMode: boolean = false;
    let searchQuery: string = '';
    let processing: boolean = false;
    let downloading: boolean = false;
    let deleting: boolean = false;
    let reloadTrigger: number = 0;

    onMount(() => {
        $mainMenu.currentPage = 'PageJobModifyTimeWindowRule';
    });

    async function handleRemoveAll() {
        if (!confirm($_('confirm_delete_all_rules'))) {
            return;
        }
        deleting = true;
        try {
            await JobModifyTimeWindowRuleApi.removeAll($api);
            reloadTrigger += 1;
        } catch (err) {
            console.error('removeAll', err);
            alert($_('delete_rules_error'));
        } finally {
            deleting = false;
        }
    }

    async function handleDownloadCsv() {
        downloading = true;
        try {
            const result = await JobModifyTimeWindowRuleApi.exportToCsv($api);
            const blob = new Blob([result.csv_content], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'reguly_okien_czasowych.csv';
            a.click();
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Błąd eksportu CSV:', err);
            alert($_('download_csv_error'));
        } finally {
            downloading = false;
        }
    }
</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderDuo>
            <div slot="main-header" style="text-wrap: nowrap;">
                {$_('time_window_rules')}
            </div>
            <div slot="main-buttons" style="display: flex;  gap: 10px;">
                <ButtonAddSomething
                    text={$_('Add rule')}
                    on:click={() => {
                        openModal(ModalCustom, {
                            component: JobModifyTimeWindowRuleAdd,
                            componentProps: {
                                onCreate: () => {
                                    reloadTrigger += 1;
                                    console.log('Rule created, reloading list', reloadTrigger);
                                }
                            },
                            showButtonOk: true,
                            modeView: 'white'
                        });
                    }}
                />
                <div style="display: flex; justify-content: flex-end; align-items: center; gap: 10px;">
                    {#if processing}
                        <IconPending spin={true} scale={0.6} />
                    {/if}
                    <ButtonSmallBlack disabled={processing} text={$_('apply_changes')} on:click={()=>{
                processing = true;
                JobModifyTimeWindowRuleApi.applyTimeWindowRules($api)
                    .then(res => {
                        console.log('applyTimeWindowRules', res);
                        alert($_('changes_applied_count', { values: { count: res.updated_job_ids.length } }));
                    })
                    .catch(err => {
                        console.error('applyTimeWindowRules', err);
                        alert($_('apply_changes_error'));
                    }).finally(() => {
                        processing = false;
                    });
            }}/>
                </div>
            </div>
        </TemplateHeaderDuo>
        <div style="margin-top: 15px; display: flex; justify-content: center; align-items: center; gap: 10px;">
            <div style="width: 100%;">
                <div style="width: 100%; display: flex; align-items: flex-start;">
                    <SearchInput
                        bind:query={searchQuery}
                        placeholder={$_('search_rule_placeholder')}
                        onKeyup={(v) => { searchQuery = v; }}
                    />
                </div>
            </div>
            <div style="display: flex; align-items: flex-start; gap: 10px;">
                <CsvImportButton on:importComplete={() => { reloadTrigger += 1; }} />
                <ButtonSmallBlue
                    disabled={downloading}
                    text={$_('export_csv')}
                    on:click={handleDownloadCsv}
                />
                <ButtonSmallDanger
                    disabled={deleting}
                    text={$_('delete_rules')}
                    on:click={handleRemoveAll}
                />
            </div>
        </div>
    </div>
    <div slot="content-header"></div>
    <div slot="content" style="overflow-y: auto; flex: 1; display: flex; flex-direction: column;">
        <div
            style="margin: 20px 0; overflow-y: auto; flex: 1; display: flex; flex-direction: column;"
        >
            <JobModifyTimeWindowRule bind:addMode {reloadTrigger} {searchQuery} />
        </div>
    </div>
</TemplateStandard>